<template>
  <div>
    <transition name="fade">
      <div v-if="visible" class="modal-overlay" @click="handleOverlayClick">
        <div class="modal-container" @click.stop>
          <div class="modal-header">
            <div class="header-content">
              <h2 class="modal-title">{{ mode === 'create' ? '发布新职位' : '编辑职位' }} ({{ currentStep }}/2)</h2>
              <div class="header-divider"></div>
              <div class="company-name">{{ companyName }}</div>
            </div>
            <button class="close-button" @click="handleClose">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 24C5.37257 24 0 18.6274 0 12C0 5.37257 5.37257 0 12 0C18.6274 0 24 5.37257 24 12C24 18.6274 18.6274 24 12 24ZM12 1.71429C6.63486 1.71429 1.71429 6.63486 1.71429 12C1.71429 17.3651 6.63486 22.2857 12 22.2857C17.3651 22.2857 22.2857 17.3651 22.2857 12C22.2857 6.63486 17.3651 1.71429 12 1.71429ZM17.3777 17.4634C17.2717 17.5697 17.1457 17.6539 17.0071 17.7114C16.8684 17.7689 16.7198 17.7985 16.5697 17.7985C16.4196 17.7985 16.271 17.7689 16.1324 17.7114C15.9937 17.6539 15.8678 17.5697 15.7617 17.4634L12.1251 13.8274L8.48857 17.4634C8.27428 17.6778 7.9836 17.7983 7.68049 17.7983C7.37738 17.7984 7.08666 17.678 6.87229 17.4637C6.65792 17.2494 6.53745 16.9587 6.5374 16.6556C6.53735 16.3525 6.6577 16.0618 6.872 15.8474L10.5086 12.2109L6.872 8.57429C6.6577 8.35991 6.53735 8.0692 6.5374 7.76608C6.53745 7.46297 6.65792 7.1723 6.87229 6.958C7.08666 6.7437 7.37738 6.62335 7.68049 6.6234C7.9836 6.62345 8.27428 6.74392 8.48857 6.95829L12.1251 10.5949L15.7617 6.95829C15.8671 6.84913 15.9932 6.76207 16.1327 6.70217C16.2721 6.64227 16.4221 6.61075 16.5738 6.60943C16.7256 6.60811 16.8761 6.63703 17.0165 6.69449C17.157 6.75195 17.2846 6.83681 17.3919 6.94412C17.4992 7.05143 17.584 7.17903 17.6415 7.31948C17.699 7.45993 17.7279 7.61042 17.7266 7.76217C17.7253 7.91392 17.6937 8.06389 17.6338 8.20332C17.5739 8.34275 17.4869 8.46886 17.3777 8.57429L13.7411 12.2109L17.3777 15.8474C17.592 16.0617 17.7123 16.3524 17.7123 16.6554C17.7123 16.9585 17.592 17.2491 17.3777 17.4634Z" fill="white"/>
              </svg>
            </button>
          </div>

          <div class="modal-body">
            <el-skeleton v-if="loading" :rows="8" animated />
            
            <div v-else-if="currentStep === 1" class="step-content">
              <el-form ref="step1Form" :model="form" :rules="step1Rules" label-position="top">
                <div class="form-section">
                  <h3 class="section-title">职位基本信息</h3>
                  
                  <el-form-item label="招聘类型" prop="recruitment_type">
                    <el-select v-model="form.recruitment_type" placeholder="请选择招聘类型" class="form-select">
                      <el-option 
                        v-for="type in RECRUITMENT_TYPES" 
                        :key="type.value" 
                        :label="type.label" 
                        :value="type.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="职位名称" prop="title">
                    <el-input v-model="form.title" placeholder="请输入职位名称" class="form-input"></el-input>
                  </el-form-item>

                  <el-form-item label="职位类型" prop="category">
                    <el-autocomplete
                      v-model="form.category"
                      :fetch-suggestions="queryCategorySuggestions"
                      placeholder="请输入职位类型"
                      class="form-input"
                      :trigger-on-focus="false"
                      @select="handleCategorySelect"
                      clearable
                    >
                      <template #default="{ item }">
                        <div class="category-suggestion">
                          <span class="category-text">{{ item.value }}</span>
                        </div>
                      </template>
                    </el-autocomplete>
                  </el-form-item>
                </div>

                <div class="form-section">
                  <h3 class="section-title">薪资范围</h3>
                  <div class="salary-container">
                    <div class="salary-input-group">
                      <el-form-item prop="salary_start" class="salary-form-item">
                        <el-input v-model="form.salary_start" :placeholder="isInternship ? '请输入最低日薪' : '请输入最低薪资'" class="salary-input"></el-input>
                      </el-form-item>
                      <span class="salary-unit">{{ salaryUnit }}</span>
                      <span class="salary-separator">-</span>
                      <el-form-item prop="salary_end" class="salary-form-item">
                        <el-input v-model="form.salary_end" :placeholder="isInternship ? '请输入最高日薪' : '请输入最高薪资'" class="salary-input"></el-input>
                      </el-form-item>
                      <span class="salary-unit">{{ salaryUnit }}</span>
                      <span v-if="!isInternship" class="salary-clear">×</span>
                      <el-form-item v-if="!isInternship" prop="salary_month" class="salary-form-item">
                        <el-input v-model="form.salary_month" placeholder="请输入月数" class="salary-input"></el-input>
                      </el-form-item>
                      <span v-if="!isInternship" class="salary-unit">月</span>
                      <span v-if="isInternship" class="salary-unit">/天</span>
                    </div>
                    <div class="salary-tip">温馨提示:输入的最低薪资不得高于最高薪资</div>
                  </div>
                </div>

                <div class="form-section">
                  <h3 class="section-title">工作地点</h3>
                  <el-form-item prop="workLocation">
                    <div class="location-group" @click="getCurrentLocation">
                      <el-input 
                        v-model="form.workLocation" 
                        placeholder="点击获取当前位置或手动输入地址" 
                        class="location-input"
                        readonly
                      >
                        <template #suffix>
                          <i class="el-icon-location" style="cursor: pointer; color: #7EB4EB;"></i>
                        </template>
                      </el-input>
                      <button 
                        type="button" 
                        class="map-select-btn"
                        @click="openMapSelector"
                      >
                        选择位置
                      </button>
                    </div>
                  </el-form-item>
                </div>

                <div class="form-section">
                  <h3 class="section-title">职位描述</h3>
                  <el-form-item prop="description">
                    <el-input
                      v-model="form.description"
                      type="textarea"
                      :rows="6"
                      placeholder="请详细描述该职位的工作内容、职责等"
                      class="form-textarea">
                    </el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>

            <div v-else-if="currentStep === 2" class="step-content">
              <el-form ref="step2Form" :model="form" :rules="step2Rules" label-position="top">
                <div class="form-section">
                  <h3 class="section-title">职位要求</h3>
                  
                  <el-form-item label="经验要求" prop="experience">
                    <el-select v-model="form.experience" placeholder="请选择经验要求" class="form-select">
                      <el-option 
                        v-for="option in POSITION_EXPERIENCE_OPTIONS" 
                        :key="option.value" 
                        :label="option.label" 
                        :value="option.value">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="学历要求" prop="education">
                    <el-select v-model="form.education" placeholder="请选择学历要求" class="form-select">
                      <el-option 
                        v-for="option in POSITION_EDUCATION_OPTIONS" 
                        :key="option.value" 
                        :label="option.label" 
                        :value="option.value">
                      </el-option>
                    </el-select>
                  </el-form-item>


                  <el-form-item label="职位关键词" prop="job_keywords">
                    <div class="keywords-container">
                      <div class="keyword-input-with-btn">
                        <el-input v-model="keywordInput" placeholder="请输入关键词 (每个关键词最多6个字)" class="keyword-input">
                          <template #suffix>
                            <button type="button" class="add-keyword-btn" @click="addKeyword">添加</button>
                          </template>
                        </el-input>
                      </div>
                      <div class="keyword-tags" v-if="form.job_keywords && form.job_keywords.length > 0">
                        <span v-for="(keyword, index) in form.job_keywords" :key="index" class="keyword-tag">
                          <span>{{ keyword }}</span>
                          <i class="el-icon-close" @click="removeKeyword(index)"></i>
                        </span>
                      </div>
                      <div class="keyword-tip" v-if="!form.job_keywords || form.job_keywords.length === 0">请添加关键词</div>
                    </div>
                  </el-form-item>

                  <el-form-item label="任职要求" prop="requirement">
                    <el-input
                      v-model="form.requirement"
                      type="textarea"
                      :rows="6"
                      placeholder="请详细描述该职位的任职要求、能力素质等"
                      class="form-textarea">
                    </el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>

          <div class="modal-footer">
            <button class="clear-form-btn" @click="clearForm">清空当前表单</button>
            <div class="action-buttons">
              <button v-if="currentStep === 2" class="prev-step-btn" @click="prevStep">上一步</button>
              <button v-if="currentStep === 1" class="next-step-btn" @click="nextStep">下一步</button>
              <button v-if="currentStep === 2" class="publish-btn" @click="handleSubmit">{{ mode === 'create' ? '发布' : '保存' }}</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div v-if="mapVisible" class="map-modal-overlay" @click="closeMapSelector">
        <div class="map-modal-container" @click.stop>
          <div class="map-modal-header">
            <h3>选择工作地点</h3>
            <button class="map-close-btn" @click="closeMapSelector">
              <i class="el-icon-close"></i>
            </button>
          </div>
          <div class="map-modal-body">
            <div class="map-search-container">
              <el-input
                v-model="searchQuery"
                placeholder="搜索地点..."
                class="map-search-input"
                @input="searchLocation"
                clearable
              >
                <template #prefix>
                  <i class="el-icon-search"></i>
                </template>
              </el-input>
            </div>
            
            <div class="map-container" ref="mapContainer">
              <div class="map-placeholder" v-if="!mapLoaded">
                <i class="el-icon-location-outline"></i>
                <p>正在加载地图...</p>
              </div>
            </div>
            
            <div class="search-results" v-if="searchResults.length > 0">
              <div class="search-results-title">搜索结果</div>
              <div class="search-results-list">
                <div 
                  v-for="(place, index) in searchResults" 
                  :key="index"
                  class="search-result-item"
                  @click="selectPlace(place)"
                >
                  <div class="place-name">{{ place.name }}</div>
                  <div class="place-address">{{ place.address }}</div>
                </div>
              </div>
            </div>
            
            <div class="map-actions">
              <button class="cancel-btn" @click="closeMapSelector">取消</button>
              <button class="confirm-btn" @click="confirmLocation" :disabled="!selectedPlace">确认选择</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { editPosition, getJobInfo } from '@/api/position'
import { RECRUITMENT_TYPES, POSITION_EDUCATION_OPTIONS, POSITION_EXPERIENCE_OPTIONS } from '@/utils/constants'
import AMapLoader from '@amap/amap-jsapi-loader'
import { getBusinessCenter } from '@/api/user'

export default {
  name: 'EditPositionModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    jobId: {
      type: [String, Number],
      default: null
    },
    mode: {
      type: String,
      default: 'edit', 
      validator: value => ['edit', 'create'].includes(value)
    }
  },
  data() {
    return {
      loading: false,
      currentStep: 1,
      keywordInput: '',
      companyName: '', // 默认公司名称
      isEditingLocation: false,
      
      mapVisible: false,
      mapLoaded: false,
      map: null,
      geocoder: null,
      searchQuery: '',
      searchResults: [],
      selectedPlace: null,
      currentPosition: null,
      AMap: null,
        config: {
                    securityJsCode: '4e3dc9d8adf7fcd98960bf4af3b42672', 
          key: '070c88801a00691beb776e97b827de22',

          version: '2.0',
          plugins: ['AMap.Geocoder', 'AMap.PlaceSearch', 'AMap.AutoComplete'],
          Loca: { version: '2.0' }
        },
      RECRUITMENT_TYPES,
      POSITION_EDUCATION_OPTIONS,
      POSITION_EXPERIENCE_OPTIONS,
      
      categoryOptions: [
        '后端开发',
        '前端/移动开发', 
        '测试',
        '运维/技术支持',
        '产品经理',
        '算法工程师',
        '化工/能源/环保',
        '产品运营',
        '产品设计',
        '产品助理',
        '产品总监',
        '产品专员',
        '数据分析师',
        '数据工程师',
        '数据科学家',
        'UI设计师',
        'UX设计师',
        '平面设计师',
        '视觉设计师',
        '交互设计师',
        'Java开发工程师',
        'Python开发工程师',
        '前端工程师',
        '后端工程师',
        '全栈工程师',
        '移动端开发',
        'iOS开发',
        'Android开发',
        'React开发',
        'Vue开发',
        'Node.js开发',
        'PHP开发',
        'C++开发',
        'Go开发',
        '测试工程师',
        '自动化测试',
        '性能测试',
        '安全测试',
        '运维工程师',
        'DevOps工程师',
        '系统管理员',
        '网络工程师',
        '技术支持',
        '技术总监',
        '技术经理',
        '架构师',
        '项目经理',
        '项目助理',
        '销售经理',
        '销售代表',
        '市场经理',
        '市场专员',
        '运营经理',
        '运营专员',
        '内容运营',
        '用户运营',
        '活动运营',
        '新媒体运营',
        '人力资源',
        'HRBP',
        '招聘专员',
        '培训专员',
        '财务经理',
        '会计',
        '出纳',
        '审计',
        '法务',
        '律师',
        '行政助理',
        '行政经理',
        '客服',
        '客服经理',
        '商务拓展',
        'BD经理',
        '投资经理',
        '风控经理',
        '合规经理'
      ],
      form: {
        id: null,
        title: '',
        category: '',
        recruitment_type: null,
        education: null,
        city: '',
        experience: null,
        status: null,
        description: '',
        requirement: '',
        apply_count: 0,
        salary_start: null,
        salary_end: null,
        salary_month: null,
        job_keywords: null,
        workLocation: ''
      },
      initialForm: null, // 保存初始数据
      step1Rules: {
        recruitment_type: [
          { required: true, message: '请选择招聘类型', trigger: 'change' }
        ],
        title: [
          { required: true, message: '请输入职位名称', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请输入职位类型', trigger: 'blur' }
        ],
        salary_start: [
          { required: true, message: '请输入最低薪资', trigger: 'blur' }
        ],
        salary_end: [
          { required: true, message: '请输入最高薪资', trigger: 'blur' }
        ],
        salary_month: [
          { required: true, message: '请输入月数', trigger: 'blur' }
        ],
        workLocation: [
          { required: true, message: '请填写工作地点', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入职位描述', trigger: 'blur' }
        ]
      },
      step2Rules: {
        experience: [
          { required: true, message: '请选择经验要求', trigger: 'change' }
        ],
        education: [
          { required: true, message: '请选择学历要求', trigger: 'change' }
        ],
        job_keywords: [
          { required: true, message: '请添加职位关键词', trigger: 'change' }
        ],
        requirement: [
          { required: true, message: '请输入任职要求', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    jobId: {
      immediate: true,
      handler() {
        if (this.jobId && this.mode === 'edit') {
          this.loadJobInfo()
        } else if (this.mode === 'create') {
          this.resetForm()
        }
      }
    },
    mode: {
      immediate: true,
      handler() {
        if (this.mode === 'create') {
          this.resetForm()
        }
      }
    },
    'form.title': {
      handler() {
        this.extractKeywords()
      }
    },
    'form.description': {
      handler() {
        this.extractKeywords()
      }
    },
    'form.category': {
      handler() {
        this.extractKeywords()
      }
    }
  },
  computed: {
    // 判断是否为实习类型
    isInternship() {
      return this.form.recruitment_type === "2"
    },
    // 薪资单位
    salaryUnit() {
      return this.isInternship ? "元" : "K"
    }
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    // 获取企业用户信息，包括公司名称
    async getUserInfo() {
      try {
        const response = await getBusinessCenter()
        if (response.data.code === 1) {
          const userInfo = response.data.data || {}
          // 更新公司名称
          if (userInfo.company_name) {
            this.companyName = userInfo.company_name
          }
          // 如果获取到公司地址，直接填充到工作地点
          if (userInfo.company_address && !this.form.workLocation) {
            this.form.workLocation = userInfo.company_address
          }
        } else {
          console.error('获取企业信息失败:', response.data.msg)
        }
      } catch (error) {
        console.error('获取企业信息异常:', error)
        // 失败时使用默认公司名称
      }
    },

    async initAMap() {
      try {
        this.AMap = await AMapLoader.load(this.config)
        this.initMap()
      } catch (error) {
        console.error('AMap initialization failed:', error)
        this.$message.error(`地图加载失败: ${error.message}`)
      }
    },

    initMap() {
      if (!this.AMap) {
        console.error('高德地图API未加载')
        return
      }
      
      // 确保DOM元素存在
      if (!this.$refs.mapContainer) {
        console.error('地图容器未找到')
        return
      }
      
      try {
        this.map = new this.AMap.Map(this.$refs.mapContainer, {
          zoom: 13,
          center: [116.397428, 39.90923], 
          mapStyle: 'amap://styles/normal'
        })
        
        this.geocoder = new this.AMap.Geocoder({
          city: '全国'
        })
        
        this.mapLoaded = true
        
        this.map.on('click', (e) => {
          this.handleMapClick(e.lnglat)
        })
      } catch (error) {
        console.error('地图实例创建失败:', error)
        this.$message.error('地图创建失败: ' + error.message)
      }
    },

    async searchLocation() {
      if (!this.searchQuery.trim()) {
        this.searchResults = []
        return
      }
      
      if (!this.AMap) {
        this.searchResults = [
          { name: '深圳市南山区丽水路2279号', address: '清华大学深圳国际研究生院', location: [113.9345, 22.5405] },
          { name: '深圳市南山区科技园', address: '深圳市南山区科技园南区', location: [113.9345, 22.5405] }
        ]
        return
      }
      
      const placeSearch = new this.AMap.PlaceSearch({
        city: '深圳',
        pageSize: 10
      })
      
      placeSearch.search(this.searchQuery, (status, result) => {
        if (status === 'complete' && result.poiList) {
          this.searchResults = result.poiList.pois.map(poi => ({
            name: poi.name,
            address: poi.address,
            location: poi.location
          }))
        } else {
          this.searchResults = []
        }
      })
    },

    selectPlace(place) {
      this.selectedPlace = place
      
      if (this.map && this.AMap) {
        this.map.clearMap()
        const marker = new this.AMap.Marker({
          position: place.location,
          title: place.name
        })
        this.map.add(marker)
        this.map.setCenter(place.location)
      } else {
        this.$message.warning('地图未正确加载，无法标记位置')
      }
    },

    handleMapClick(lnglat) {
      const location = [lnglat.lng, lnglat.lat]
      
      if (this.geocoder) {
        this.geocoder.getAddress(location, (status, result) => {
          if (status === 'complete' && result.regeocode) {
            this.selectedPlace = {
              name: result.regeocode.formattedAddress,
              address: result.regeocode.formattedAddress,
              location: location
            }
            
            this.map.clearMap()
            const marker = new this.AMap.Marker({
              position: location,
              title: result.regeocode.formattedAddress
            })
            this.map.add(marker)
          }
        })
      }
    },

    confirmLocation() {
      if (this.selectedPlace) {
        this.form.workLocation = this.selectedPlace.address
        this.mapVisible = false
        this.$message.success('位置选择成功')
      } else {
        this.$message.warning('请先选择一个位置')
      }
    },

    openMapSelector() {
      this.mapVisible = true
      this.searchQuery = ''
      this.searchResults = []
      this.selectedPlace = null
      
      // 等待DOM渲染完成后再初始化地图
      this.$nextTick(async () => {
        try {
          await this.initAMap()
          // 确保地图容器有尺寸后再设置视图
          setTimeout(() => {
            if (this.map) {
              this.map.setFitView()
            }
          }, 100)
        } catch (error) {
          console.error('地图初始化失败:', error)
          this.$message.error('地图加载失败，请重试')
        }
      })
    },

    closeMapSelector() {
      this.mapVisible = false
      this.searchQuery = ''
      this.searchResults = []
      this.selectedPlace = null
    },

    async loadJobInfo() {
      this.loading = true
      try {
        const response = await getJobInfo({ id: this.jobId })
        if (response.data.code === 1) { 
          const data = response.data.data
          
          // 处理薪资数据，如果是实习类型需要解析字符串
          let salary_start = data.salary_start
          let salary_end = data.salary_end
          
          // 如果是实习类型（recruitment_type === "2"），解析 salary_start 字符串
          if (data.recruitment_type === "2" && typeof data.salary_start === 'string') {
            // 解析格式："start元-end元/天"
            const match = data.salary_start.match(/(\d+)元-(\d+)元\/天/)
            if (match) {
              salary_start = parseInt(match[1])
              salary_end = parseInt(match[2])
            }
          }
          
          this.form = {
            id: data.id,
            title: data.title,
            category: data.category,
            recruitment_type: data.recruitment_type,
            education: data.education,
            city: data.city,
            experience: data.experience,
            status: data.status,
            description: data.description,
            requirement: data.requirement,
            apply_count: data.apply_count,
            salary_start: salary_start,
            salary_end: salary_end,
            salary_month: data.salary_month,
            job_keywords: data.job_keywords ? data.job_keywords.split(',') : [],
            workLocation: data.job_address
          }
          
          // 保存初始数据
          this.initialForm = JSON.parse(JSON.stringify(this.form))
        } else {
          this.$message.error(response.data.msg || '获取职位信息失败')
        }
      } catch (error) {
        console.error('加载职位信息异常:', error)
        this.$message.error('加载职位信息失败，请重试')
      } finally {
        this.loading = false
      }
    },
    
    nextStep() {
      this.$refs.step1Form.validate((valid) => {
        if (valid) {
          this.currentStep = 2
        }
      })
    },

    prevStep() {
      this.currentStep = 1
    },

    addKeyword() {
      if (this.keywordInput.trim() && this.keywordInput.length <= 6) {
        if (!this.form.job_keywords) {
          this.form.job_keywords = []
        }
        this.form.job_keywords.push(this.keywordInput.trim())
        this.keywordInput = ''
      } else if (this.keywordInput.length > 6) {
        this.$message.warning('每个关键词最多6个字')
      }
    },

    removeKeyword(index) {
      this.form.job_keywords.splice(index, 1)
    },

    clearForm() {
      this.$confirm('确定要清空当前表单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form = {
          id: this.form.id,
          title: '',
          category: '',
          recruitment_type: null,
          education: null,
          city: '北京',
          experience: null,
          status: 3,
          description: '',
          requirement: '',
          apply_count: 0,
          salary_start: null,
          salary_end: null,
          salary_month: null,
          job_keywords: [],
          workLocation: '深圳市南山区丽水路2279号清华大学深圳国际研究生院'
        }
        this.currentStep = 1
        this.keywordInput = ''
      })
    },

    async handleSubmit() {
      try {
        console.log('开始表单校验...')
        console.log('当前表单数据:', this.form)
        
        // 根据当前步骤验证对应的表单
        if (this.currentStep === 2) {
          // 如果是步骤2，只需要验证step2Form
          await this.$refs.step2Form.validate()
          console.log('第二步表单校验通过')
        } else if (this.currentStep === 1) {
          // 如果是步骤1，验证step1Form（理论上不应该在这里，因为按钮只在步骤2显示）
          await this.$refs.step1Form.validate()
          console.log('第一步表单校验通过')
        }
        
        if (!this.form.job_keywords || this.form.job_keywords.length === 0) {
          console.log('关键词为空，尝试自动提取...')
          this.extractKeywords()
          if (!this.form.job_keywords || this.form.job_keywords.length === 0) {
            this.$message.error('请至少添加一个职位关键词')
            return
          }
        }
        
        console.log('所有校验通过，开始提交...')
        
        let response
        if (this.mode === 'create') {
          const { publishPosition } = await import('@/api/position')
          const publishData = this.formatPublishData(this.form)
          console.log('发布数据:', publishData)
          response = await publishPosition(publishData)
        } else {
          const editData = this.formatEditData(this.form)
          console.log('编辑数据:', editData)
          response = await editPosition(editData)
        }
        
        console.log('API响应:', response)
        
        if (response.data.code === 1) {
          this.$message.success(this.mode === 'create' ? '职位发布成功！' : '职位更新成功！')
          
          // 如果是编辑模式，更新初始数据
          if (this.mode === 'edit') {
            this.initialForm = JSON.parse(JSON.stringify(this.form))
          }
          
          this.handleClose()
          this.$emit('refresh')
        } else {
          this.$message.error(response.data.msg || (this.mode === 'create' ? '职位发布失败，请重试' : '职位更新失败，请重试'))
        }
      } catch (error) {
        console.error('表单校验失败:', error)
        console.error('错误详情:', error.message)
        this.$message.error('请检查表单填写是否完整')
      }
    },
    
    formatPublishData(formData) {
      
      console.log('formatPublishData formData.recruitment_type:', formData.recruitment_type)
      
      const isInternship = formData.recruitment_type === "2"
      
      // 如果是实习类型，将薪资格式化为特殊字符串格式
      let salary_start = formData.salary_start
      let salary_end = formData.salary_end
      let salary_month = formData.salary_month
      
      if (isInternship) {
        // 实习类型：格式化为 "start元-end元/天"
        salary_start = `${formData.salary_start}元-${formData.salary_end}元/天`
        salary_end = null // 实习类型不需要 salary_end
        // 实习类型不需要月数，设置为 null
        salary_month = null
      }
      
      return {
        category: formData.category,
        city: formData.city,
        description: formData.description,
        education: formData.education,
        experience: formData.experience,
        job_address: formData.workLocation,
        job_keywords: formData.job_keywords ? formData.job_keywords.join(',') : '',
        recruitment_type: formData.recruitment_type,
        requirement: formData.requirement,
        salary_end: salary_end,
        salary_month: salary_month,
        salary_start: salary_start,
        status: 1,
        title: formData.title,
      }
    },



    formatEditData(formData) {
      
      console.log('formatEditData formData.recruitment_type:', formData.recruitment_type)
      
      const isInternship = formData.recruitment_type === "2"
      
      // 如果是实习类型，将薪资格式化为特殊字符串格式
      let salary_start = formData.salary_start
      let salary_end = formData.salary_end
      let salary_month = formData.salary_month
      
      if (isInternship) {
        // 实习类型：格式化为 "start元-end元/天"
        salary_start = `${formData.salary_start}元-${formData.salary_end}元/天`
        salary_end = null // 实习类型不需要 salary_end
        // 实习类型不需要月数，设置为 null
        salary_month = null
      }
      
      return {
        id: formData.id,
        category: formData.category,
        city: formData.city,
        description: formData.description,
        education: formData.education,
        experience: formData.experience,
        job_address: formData.workLocation,
        job_keywords: formData.job_keywords ? formData.job_keywords.join(',') : '',
        recruitment_type: formData.recruitment_type,
        requirement: formData.requirement,
        salary_end: salary_end,
        salary_month: salary_month,
        salary_start: salary_start,
        status: formData.status,
        title: formData.title,
      }
    },

    resetForm() {
      this.form = {
        id: null,
        title: '',
        category: '',
        recruitment_type: null,
        education: null,
        city: '',
        experience: null,
        status: null,
        description: '',
        requirement: '',
        apply_count: 0,
        salary_start: null,
        salary_end: null,
        salary_month: null,
        job_keywords: [],
        workLocation: ''
      }
      this.currentStep = 1
      this.keywordInput = ''
      this.isEditingLocation = false
    },
    
    handleClose() {
      this.$emit('update:visible', false)
      this.currentStep = 1
      this.keywordInput = ''
      this.isEditingLocation = false
      this.mapVisible = false
      
      // 如果是编辑模式，恢复到初始数据
      if (this.mode === 'edit' && this.initialForm) {
        this.form = JSON.parse(JSON.stringify(this.initialForm))
      }
    },

    handleOverlayClick() {
      this.handleClose()
    },

    
    queryCategorySuggestions(queryString, callback) {
      if (!queryString) {
        callback([])
        return
      }
      
      const results = this.categoryOptions
        .filter(category => category.toLowerCase().includes(queryString.toLowerCase()))
        .map(category => ({ value: category }))
      
      callback(results)
    },

    
    handleCategorySelect(item) {
      this.form.category = item.value
    },

    
    getCurrentLocation() {
      if (!navigator.geolocation) {
        this.$message.error('您的浏览器不支持地理定位功能')
        return
      }

      this.$message.info('正在获取当前位置...')
      
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords
          this.currentPosition = { lat: latitude, lng: longitude }
          this.reverseGeocode(latitude, longitude)
        },
        (error) => {
          console.error('获取位置失败:', error)
          let errorMessage = '获取位置失败'
          switch(error.code) {
            case error.PERMISSION_DENIED:
              errorMessage = '用户拒绝了地理定位请求'
              break
            case error.POSITION_UNAVAILABLE:
              errorMessage = '位置信息不可用'
              break
            case error.TIMEOUT:
              errorMessage = '获取位置超时'
              break
          }
          this.$message.error(errorMessage)
          // 如果获取位置失败，使用模拟地址
          const mockAddress = `深圳市南山区丽水路2279号清华大学深圳国际研究生院`
          this.form.workLocation = mockAddress
          this.$message.info('已使用默认地址')
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 60000
        }
      )
    },

    
    reverseGeocode(lat, lng) {
      if (!this.geocoder) {
        const mockAddress = `深圳市南山区丽水路2279号清华大学深圳国际研究生院`
        setTimeout(() => {
          this.form.workLocation = mockAddress
          this.$message.success('位置获取成功（模拟地址）')
        }, 1000)
        return
      }
      
      this.geocoder.getAddress([lng, lat], (status, result) => {
        if (status === 'complete' && result.regeocode) {
          this.form.workLocation = result.regeocode.formattedAddress
          this.$message.success('位置获取成功')
        } else {
          // 如果API解析失败，使用模拟地址作为备选
          const mockAddress = `深圳市南山区丽水路2279号清华大学深圳国际研究生院`
          this.form.workLocation = mockAddress
          this.$message.warning('地址解析失败，已使用默认地址')
        }
      })
    },


    
    closeMapSelector() {
      this.mapVisible = false
      this.searchQuery = ''
      this.searchResults = []
      this.selectedPlace = null
    },


    extractKeywords() {
      const title = this.form.title || ''
      const description = this.form.description || ''
      const category = this.form.category || ''
      
      const text = `${title} ${description} ${category}`.toLowerCase()
      
      const keywordPatterns = [
        { pattern: /c端|c端产品|c端开发|c端运营|c端设计/g, keyword: 'C端产品' },
        { pattern: /b端|b端产品|b端开发|b端运营|b端设计/g, keyword: 'B端产品' },
        { pattern: /硬件|硬件开发|硬件设计|硬件工程师|硬件产品/g, keyword: '硬件' },
        { pattern: /软件|软件开发|软件设计|软件工程师|软件产品/g, keyword: '软件' },
        { pattern: /前端|前端开发|前端工程师|前端设计|web前端/g, keyword: '前端开发' },
        { pattern: /后端|后端开发|后端工程师|服务端|server/g, keyword: '后端开发' },
        { pattern: /移动端|移动开发|ios|android|app开发/g, keyword: '移动开发' },
        { pattern: /算法|算法工程师|机器学习|人工智能|ai|ml/g, keyword: '算法' },
        { pattern: /数据|数据分析|数据工程师|数据科学|大数据/g, keyword: '数据' },
        { pattern: /测试|测试工程师|自动化测试|qa|质量保证/g, keyword: '测试' },
        { pattern: /运维|运维工程师|devops|系统运维|服务器运维/g, keyword: '运维' },
        { pattern: /产品|产品经理|产品设计|产品运营|产品策划/g, keyword: '产品' },
        { pattern: /设计|ui设计|ux设计|交互设计|视觉设计/g, keyword: '设计' },
        { pattern: /运营|用户运营|内容运营|活动运营|新媒体运营/g, keyword: '运营' },
        { pattern: /销售|销售经理|销售代表|商务|bd/g, keyword: '销售' },
        { pattern: /市场|市场营销|市场推广|品牌|pr/g, keyword: '市场' },
        { pattern: /java|python|javascript|php|go|c\+\+|c#/g, keyword: '编程语言' },
        { pattern: /react|vue|angular|node\.js|express/g, keyword: '前端框架' },
        { pattern: /spring|django|flask|laravel|rails/g, keyword: '后端框架' },
        { pattern: /mysql|postgresql|mongodb|redis|elasticsearch/g, keyword: '数据库' },
        { pattern: /docker|kubernetes|jenkins|git|ci\/cd/g, keyword: 'DevOps' },
        { pattern: /aws|阿里云|腾讯云|azure|云服务/g, keyword: '云计算' },
        { pattern: /区块链|比特币|以太坊|defi|nft/g, keyword: '区块链' },
        { pattern: /物联网|iot|智能硬件|传感器|嵌入式/g, keyword: '物联网' },
        { pattern: /游戏|游戏开发|游戏设计|unity|unreal/g, keyword: '游戏' },
        { pattern: /金融|支付|银行|保险|理财/g, keyword: '金融' },
        { pattern: /教育|在线教育|培训|学习|课程/g, keyword: '教育' },
        { pattern: /医疗|健康|医院|药品|医疗器械/g, keyword: '医疗' },
        { pattern: /电商|购物|零售|供应链|物流/g, keyword: '电商' },
        { pattern: /社交|社区|聊天|直播|短视频/g, keyword: '社交' }
      ]
      
      if (!this.form.job_keywords) {
        this.form.job_keywords = []
      }
      
      const extractedKeywords = []
      const usedKeywords = new Set()
      
      keywordPatterns.forEach(({ pattern, keyword }) => {
        if (pattern.test(text) && !usedKeywords.has(keyword) && !this.form.job_keywords.includes(keyword)) {
          extractedKeywords.push(keyword)
          usedKeywords.add(keyword)
        }
      })
      
      if (extractedKeywords.length > 0) {
        this.form.job_keywords.push(...extractedKeywords.slice(0, 3))
      }
    },

  }
}
</script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-container {
  background: transparent;
  border-radius: 16px;
  width: 900px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}

.modal-header {
  border-radius: 40px 40px 0 0;
  background: linear-gradient(0deg, rgba(132, 172, 237, 0.40) 0%, rgba(132, 172, 237, 0.40) 100%), linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  box-shadow: 1px 1px 10px 0 rgba(0, 0, 0, 0.05), 4px 4px 20px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(15px);
  padding: 24px 32px;
  position: relative;
  
  .header-content {
    .modal-title {
      color: white;
      font-size: 20px;
      font-weight: 600;
      margin: 0 0 8px 0;
    }
    
    .header-divider {
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.20);
      margin: 8px 0;
    }
    
    .company-name {
      color: white;
      font-size: 14px;
      opacity: 0.9;
    }
  }
  
  .close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    
    svg {
      width: 24px;
      height: 24px;
    }
  }
}

.modal-body {
  background: white;
  padding: 32px;
  flex: 1;
  overflow-y: auto;
}

.step-content {
  .form-section {
    margin-bottom: 32px;
    
    .section-title {
      font-size: 16px;
      font-weight: 600;
      color: #1a202c;
      margin: 0 0 20px 0;
      padding-bottom: 8px;
      border-bottom: 1px solid #e2e8f0;
    }
  }
}

.form-input,
.form-select,
.form-textarea {
  width: 100%;
  
  :deep(.el-input__inner),
  :deep(.el-textarea__inner) {
    border-radius: 8px;
    border: 1px solid #d1d5db;
    padding: 12px 16px;
    font-size: 14px;
    
    &:focus {
      border-color: #7EB4EB;
      box-shadow: 0 0 0 3px rgba(126, 180, 235, 0.1);
    }
  }
}

.salary-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  
  .salary-input {
    width: 120px;
    
    :deep(.el-input__inner) {
      text-align: center;
    }
  }
  
  .salary-unit {
    color: #6b7280;
    font-size: 14px;
    font-weight: 500;
  }
  
  .salary-separator {
    color: #6b7280;
    font-size: 16px;
    font-weight: 500;
  }
  
  .salary-clear {
    color: #6b7280;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    
    &:hover {
      color: #ef4444;
    }
  }
}

.salary-container {
  display: flex;
  align-items: center;
  gap: 20px;
  
  .salary-input-group {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    
    .salary-form-item {
      margin-bottom: 0;
      
      :deep(.el-form-item__content) {
        margin-left: 0;
      }
      
      :deep(.el-form-item__error) {
        position: absolute;
        top: 100%;
        left: 0;
        font-size: 12px;
      }
    }
  }
  
  .salary-tip {
    background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 12px;
    white-space: nowrap;
    flex-shrink: 0;
  }
}

.location-group {
  display: flex;
  align-items: center;
  gap: 12px;
  
  .location-input {
    flex: 1;
  }
  
  .map-select-btn {
    background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
    border: none;
    color: white;
    font-size: 14px;
    cursor: pointer;
    padding: 0px 8px;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(126, 180, 235, 0.3);
    }
    
    &:active {
      transform: translateY(0);
    }
  }
}

.keywords-container {
  .keyword-input-with-btn {
    margin-bottom: 12px;
    
    .keyword-input {
      :deep(.el-input__suffix) {
        right: 8px;
      }
    }
    
    .add-keyword-btn {
      background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      border: none;
      padding: 4px 12px;
      cursor: pointer;
      font-size: 12px;
      height: 24px;
      line-height: 1;
      
      &:hover {
        opacity: 0.8;
      }
    }
  }
}

.keyword-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
  
  .keyword-tag {
    border-radius: 12px;
    background: linear-gradient(90deg, rgba(119, 186, 255, 0.10) 0%, rgba(156, 65, 255, 0.10) 100%);
    padding: 4px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
    position: relative;
    
    span {
      background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    
    i {
      cursor: pointer;
      font-size: 12px;
      color: #62AFFF;
      
      &:hover {
        color: #ef4444;
      }
    }
  }
}

.keyword-tip {
  font-size: 12px;
  cursor: pointer;
  border-radius: 500px;
  background: linear-gradient(90deg, rgba(119, 186, 255, 0.10) 0%, rgba(156, 65, 255, 0.10) 100%);
  padding: 8px 16px;
  display: inline-block;
  border: none;
  position: relative;
  
  &::before {
    content: '请添加关键词';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--linear-2-paints, linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    border-radius: 500px;
    padding: 8px 16px;
  }
}

.modal-footer {
  background: white;
  padding: 24px 32px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  .clear-form-btn {
    background: white;
    border: 1px solid #d1d5db;
    color: #656587;
    padding: 10px 20px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    
    &:hover {
      border-color: #9ca3af;
      background: #f9fafb;
    }
  }
  
  .action-buttons {
    display: flex;
    gap: 12px;
    
    .prev-step-btn,
    .next-step-btn {
      background: white;
      border: 1px solid #d1d5db;
      color: #6b7280;
      padding: 10px 20px;
      border-radius: 8px;
      cursor: pointer;
      font-size: 14px;
      
      &:hover {
        border-color: #9ca3af;
        background: #f9fafb;
      }
    }
    
    .publish-btn {
      background: #6b7280;
      border: none;
      color: white;
      padding: 10px 20px;
      border-radius: 8px;
      cursor: pointer;
      font-size: 14px;
      
      &:hover {
        background: #4b5563;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

:deep(.el-form-item) {
  margin-bottom: 20px;
  
  .el-form-item__label {
    color: #374151;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 8px;
    display: block;
  }
  
  .el-form-item__content {
    margin-left: 0 !important;
  }
  
  .el-form-item__error {
    color: #ef4444;
    font-size: 12px;
  }
}

:deep(.el-form-item__label::after) {
  content: '*';
  color: #ef4444;
  margin-left: 4px;
}


.category-suggestion {
  padding: 8px 0;
  
  .category-text {
    font-size: 14px;
    color: #374151;
  }
}

:deep(.el-autocomplete-suggestion) {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  
  .el-autocomplete-suggestion__list {
    padding: 4px 0;
  }
  
  .el-autocomplete-suggestion__item {
    padding: 8px 16px;
    font-size: 14px;
    
    &:hover {
      background-color: #f3f4f6;
    }
    
    &.highlighted {
      background-color: #e0f2fe;
      color: #0369a1;
    }
  }
}


.map-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}

.map-modal-container {
  background: white;
  border-radius: 12px;
  width: 800px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}

.map-modal-header {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  h3 {
    color: white;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }
  
  .map-close-btn {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    
    i {
      font-size: 18px;
    }
  }
}

.map-modal-body {
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  
  .map-search-container {
    margin-bottom: 16px;
    
    .map-search-input {
      :deep(.el-input__inner) {
        border-radius: 8px;
        border: 1px solid #d1d5db;
        padding: 12px 16px;
        font-size: 14px;
        
        &:focus {
          border-color: #7EB4EB;
          box-shadow: 0 0 0 3px rgba(126, 180, 235, 0.1);
        }
      }
    }
  }
  
  .map-container {
    flex: 0 0 300px;
    min-height: 300px;
    height: 300px;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 16px;
    position: relative;
    
    .map-placeholder {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #f8f9fa;
      
      i {
        font-size: 48px;
        color: #7EB4EB;
        margin-bottom: 16px;
      }
      
      p {
        color: #6b7280;
        font-size: 14px;
        margin: 4px 0;
      }
    }
  }
  
  .search-results {
    margin-bottom: 16px;
    flex-shrink: 0;
    
    .search-results-title {
      font-size: 14px;
      font-weight: 600;
      color: #374151;
      margin-bottom: 8px;
    }
    
    .search-results-list {
      max-height: 150px;
      overflow-y: auto;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      
      .search-result-item {
        padding: 12px 16px;
        border-bottom: 1px solid #f3f4f6;
        cursor: pointer;
        transition: background-color 0.2s;
        
        &:hover {
          background-color: #f8f9fa;
        }
        
        &:last-child {
          border-bottom: none;
        }
        
        .place-name {
          font-size: 14px;
          font-weight: 500;
          color: #1f2937;
          margin-bottom: 4px;
        }
        
        .place-address {
          font-size: 12px;
          color: #6b7280;
        }
      }
    }
  }
  
  .map-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    flex-shrink: 0;
    margin-top: auto;
    
    .cancel-btn {
      background: white;
      border: 1px solid #d1d5db;
      color: #6b7280;
      padding: 10px 20px;
      border-radius: 6px;
      cursor: pointer;
      font-size: 14px;
      
      &:hover {
        border-color: #9ca3af;
        background: #f9fafb;
      }
    }
    
    .confirm-btn {
      background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
      border: none;
      color: white;
      padding: 10px 20px;
      border-radius: 6px;
      cursor: pointer;
      font-size: 14px;
      
      &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(126, 180, 235, 0.3);
      }
      
      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
}
</style>
